import api from "@/lib/api";

const DB_NAME = "equipr-outbox";
const MAX_AGE_MS = 7 * 24 * 3600 * 1000;

function openDb() {
  return new Promise((res, rej) => {
    const r = indexedDB.open(DB_NAME, 1);
    r.onupgradeneeded = () => r.result.createObjectStore("outbox", { keyPath: "id" });
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });
}
const store = (db, mode) => db.transaction("outbox", mode).objectStore("outbox");
const req = (q) => new Promise((res, rej) => { q.onsuccess = () => res(q.result); q.onerror = () => rej(q.error); });

export async function queueSubmission(kind, url, body) {
  const db = await openDb();
  const item = { id: body.client_ref || crypto.randomUUID(), kind, url, body, queued_at: new Date().toISOString() };
  await req(store(db, "readwrite").put(item));
  return item;
}

export async function listOutbox() {
  const db = await openDb();
  return (await req(store(db, "readonly").getAll())) || [];
}

async function removeItem(id) {
  const db = await openDb();
  await req(store(db, "readwrite").delete(id));
}

export const removeFromOutbox = removeItem;

let flushing = false;
export async function flushOutbox() {
  if (flushing || !navigator.onLine) return { sent: 0, remaining: (await listOutbox()).length };
  flushing = true;
  let sent = 0;
  try {
    for (const item of await listOutbox()) {
      if (Date.now() - new Date(item.queued_at).getTime() > MAX_AGE_MS) { await removeItem(item.id); continue; }
      try {
        await api.post(item.url, item.body);
        await removeItem(item.id);
        sent++;
      } catch (e) {
        const st = e.response && e.response.status;
        // drop only on permanently non-retriable client errors; keep 401/408/429 etc.
        if ([400, 403, 404, 409, 410, 422].includes(st)) await removeItem(item.id);
      }
    }
  } finally {
    flushing = false;
  }
  return { sent, remaining: (await listOutbox()).length };
}

export function initOutbox(onChange) {
  const run = () => flushOutbox().then((r) => onChange && onChange(r)).catch(() => {});
  window.addEventListener("online", run);
  const t = setInterval(run, 60000);
  run();
  return () => { window.removeEventListener("online", run); clearInterval(t); };
}
